export default __webpack_public_path__ + "static/media/mailchimp_logo.df57bb49.webp";